import { SeasonType } from "../Context/SeasonContext/SeasonContext"

export const CHAMP_SERIES_PERIOD_LENGTH = 8
export const REGULAR_SEASON_PERIOD_LENGTH = 12
export const PERIOD_SECONDS = 720
export const CHAMP_SERIES_PERIOD_SECONDS = 480

export const GAMES_STATS_SSE_ENABLED = false
export const GAME_POLLING_INTERVAL_TIME = 20000
export const GAME_CHECK_INTERVAL_TIME = 10000
export const GAME_HIGHLIGHTS_INTERVAL_TIME = 60000
// Options for season segments
export const SEASON_SEGMENT_NAMES: { [key: string]: SeasonType } = {
  regular: 'regular',
  post: 'post',
  allstar: 'allstar',
  champseries: 'champseries',
}

export const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  export const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  export const shortDays = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']